import {
  SET_RESOURCE,
  SET_RESOURCES,
  LIST_RESOURCES,
  GET_RESOURCE
} from '../actionTypes'
import { apiAction } from './api'

export const getResource = (resourceType, resourceId) => apiAction({
  url: `/${resourceType}/${resourceId}`,
  onSuccess: (resource) => {
    return setResource(resourceType, resource[Object.keys(resource)[0]], resourceId)
  },
  label: GET_RESOURCE,
  resourceType,
  resourceId
})

const setResource = (resourceType, resource, id) => {
  return {
    type: SET_RESOURCE,
    resourceType,
    resource,
    id
  }
}

export const listResources = (resourceType, params = {}, idField='id') => apiAction({
  url: `/${resourceType}`,
  params,
  onSuccess: (resources) => {
    return setResources(resourceType, resources[Object.keys(resources)[0]], idField)
  },
  label: LIST_RESOURCES,
  resourceType,
  idField
})

const setResources = (resourceType, data, idField = 'id') => {
  let resources = {};
  
  for (let i = 0; i < data.length; i++) {
    resources[data[i][idField]] = data[i]
  }
  
  return {
    type: SET_RESOURCES,
    resourceType,
    resources,
    idField
  }
}